const Welcome = () => import('~/pages/welcome').then(m => m.default || m)
const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const Register = () => import('~/pages/auth/register').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Home = () => import('~/pages/home').then(m => m.default || m)

const ModuleIndex = () => import('~/pages/module/ModuleIndex').then(m => m.default || m)
const ModuleCreate = () => import('~/pages/module/ModuleCreate').then(m => m.default || m)
const ModuleEdit = () => import('~/pages/module/ModuleEdit').then(m => m.default || m)
const ModuleIdentifier = () => import('~/pages/module/ModuleIdentifier').then(m => m.default || m)

const QuestionIndex = () => import('~/pages/question/QuestionIndex').then(m => m.default || m)
const QuestionCreate = () => import('~/pages/question/QuestionCreate').then(m => m.default || m)
const QuestionEdit = () => import('~/pages/question/QuestionEdit').then(m => m.default || m)

const AccessoryIndex = () => import('~/pages/accessory/AccessoryIndex').then(m => m.default || m)
const AccessoryCreate = () => import('~/pages/accessory/AccessoryCreate').then(m => m.default || m)
const AccessoryEdit = () => import('~/pages/accessory/AccessoryEdit').then(m => m.default || m)

const Settings = () => import('~/pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('~/pages/settings/profile').then(m => m.default || m)
const SettingsPassword = () => import('~/pages/settings/password').then(m => m.default || m)

const Carousel = () => import('~/pages/carousel/CarouselIndex').then(m => m.default || m)

const Statistic = () => import('~/pages/statistic/index').then(m => m.default || m)
const StatisticsSzafy = () => import('~/pages/statistic/szafy').then(m => m.default || m)
const StatisticsAccessories = () => import('~/pages/statistic/accessories').then(m => m.default || m)
const StatisticsQuestions = () => import('~/pages/statistic/questions').then(m => m.default || m)

const DoorIndex = () => import('~/pages/door/DoorIndex').then(m => m.default || m)
const DoorEdit = () => import('~/pages/door/DoorEdit').then(m => m.default || m)
const DoorCreate = () => import('~/pages/door/DoorCreate').then(m => m.default || m)
const DoorIdentifier = () => import('~/pages/door/DoorIdentifier').then(m => m.default || m)

export default [
  // { path: '/', name: 'welcome', component: Welcome },
  { path: '/', name: 'carousel', component: Carousel },

  { path: '/login', name: 'login', component: Login },
  { path: '/register', name: 'register', component: Register },
  { path: '/password/reset', name: 'password.request', component: PasswordEmail },
  { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },

  { path: '/admin',
    component: Home,
    children: [
      { path: '', name: 'home', redirect: { name: 'module.create' } },

      { path: 'modules', name: 'module', component: ModuleIndex },
      { path: 'module/create', name: 'module.create', component: ModuleCreate },
      { path: 'modules/:id/edit', name: 'module.edit', component: ModuleEdit },
      { path: 'modules/:id/identifier', name: 'module.identifier', component: ModuleIdentifier },

      { path: 'questions', name: 'question', component: QuestionIndex },
      { path: 'question/create', name: 'question.create', component: QuestionCreate },
      { path: 'questions/:id/edit', name: 'question.edit', component: QuestionEdit },

      { path: 'accessories', name: 'accessories', component: AccessoryIndex },
      { path: 'accessory/create', name: 'accessories.create', component: AccessoryCreate },
      { path: 'accessories/:id/edit', name: 'accessories.edit', component: AccessoryEdit },

      { path: 'doors', name: 'door', component: DoorIndex },
      { path: 'door/create', name: 'door.create', component: DoorCreate },
      { path: 'door/:id/edit', name: 'door.edit', component: DoorEdit },
      { path: 'door/:id/identifier', name: 'door.identifier', component: DoorIdentifier }
    ] },

  { path: '/settings',
    component: Settings,
    children: [
      { path: '', redirect: { name: 'settings.profile' } },
      { path: 'profile', name: 'settings.profile', component: SettingsProfile },
      { path: 'password', name: 'settings.password', component: SettingsPassword }
    ] },

  { path: '/statistic',
    component: Statistic,
    children: [
      { path: '', name: 'statistic', redirect: { name: 'statistics.questions' } },
      { path: 'questions', name: 'statistics.questions', component: StatisticsQuestions },
      { path: 'szafy', name: 'statistcs.szafy', component: StatisticsSzafy },
      { path: 'accessories', name: 'statistics.accessories', component: StatisticsAccessories }
    ] },

  { path: '*', name: 'page.notfound', component: NotFound }
]



// WEBPACK FOOTER //
// ./resources/js/router/routes.js